import { z } from 'zod';
export const marketingAudiences = ['FAMILLE', 'COUPLE', 'SENIOR', 'GROUPE'];
export const marketingChannels = [
    'wordpress',
    'linkedin',
    'facebook',
    'instagram',
    'tiktok',
];
export const createMarketingContentSchema = z.object({
    // Absent = l'IA choisit elle-même un angle éditorial distinctif
    angle: z.string().optional(),
    // Absent = tous publics
    audience: z.enum(marketingAudiences).optional(),
    channels: z.array(z.enum(marketingChannels)).min(1),
    // Absent = post d'inspiration sans offre commerciale
    offerUrl: z.string().url().optional(),
    // Contexte (période, public…) désormais fondu dans `angle` — conservé optionnel
    // pour les contenus existants.
    period: z.string().optional(),
    subject: z.string().min(1),
});
export const updateMarketingContentSchema = z.object({
    articleHtml: z.string().optional(),
    articleTitle: z.string().optional(),
    facebook: z.string().optional(),
    // Sélection d'images par canal : ids d'images EXCLUES du post de chaque
    // réseau (une nouvelle image est active partout par défaut)
    hiddenImages: z.record(z.enum(marketingChannels), z.array(z.string())).optional(),
    instagram: z.string().optional(),
    linkedin: z.string().optional(),
    tiktok: z.string().optional(),
});
export const sendMarketingContentSchema = z.object({
    // Override par canal, prioritaire sur scheduleDate. Ignoré pour tiktok
    // (toujours brouillon : la vidéo reste à produire).
    channelDates: z.record(z.enum(marketingChannels), z.string().datetime()).optional(),
    // Canaux à envoyer (sélection de la modale — plus forcément tous ceux du contenu)
    channels: z.array(z.enum(marketingChannels)).min(1),
    // Absent = brouillon Postiz ; présent = publication planifiée à cette date (ISO)
    scheduleDate: z.string().datetime().optional(),
});
// Ajout d'un canal oublié au brief : le cron génère son contenu via le
// circuit de révision (les contenus existants sont conservés)
export const addMarketingContentChannelSchema = z.object({
    channel: z.enum(marketingChannels),
});
export const regenerateMarketingContentSchema = z.object({
    instruction: z.string().min(1),
});
// Réécriture ciblée : le relecteur sélectionne un passage, l'IA réécrit
// uniquement ce passage (le texte complet ne sert que de contexte)
export const rewriteMarketingSelectionSchema = z.object({
    channel: z.enum(marketingChannels),
    fullText: z.string().min(1),
    // Absente = réécriture par défaut (corriger, fluidifier)
    instruction: z.string().optional(),
    selectedText: z.string().min(1),
});
// Édition des textes incrustés à la relecture : titre de campagne (niveau
// contenu) + titre/sous-titre/activation par image. Le serveur re-compose
// l'overlay des images concernées.
export const updateMarketingImageOverlaysSchema = z.object({
    // Absent = ne pas toucher au titre de campagne
    campaignTitle: z.string().optional(),
    images: z.array(z.object({
        id: z.string(),
        overlayEnabled: z.boolean(),
        subtitle: z.string().optional(),
        title: z.string().optional(),
    })),
});
// Génération d'images : 1 à 4 sujets (une image par sujet). Chaque sujet est
// injecté dans le prompt luxe côté serveur.
export const MAX_IMAGE_SUBJECTS = 6;
export const generateMarketingImagesSchema = z.object({
    subjects: z.array(z.string().trim().min(1)).min(1).max(MAX_IMAGE_SUBJECTS),
});
